import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Handle chunk loading errors (happens when new deployment invalidates cached HTML)
// This automatically reloads the page to get fresh assets
window.addEventListener('error', (event) => {
  const message = event.message || '';
  const error = event.error;
  
  // Detect chunk loading failures
  if (
    message.includes('ChunkLoadError') ||
    message.includes('Loading chunk') ||
    error?.name === 'ChunkLoadError' ||
    (error?.message && error.message.includes('Loading chunk'))
  ) {
    // Prevent infinite reload loop - only reload once per session
    const reloadKey = 'chunk_reload_attempted';
    if (!sessionStorage.getItem(reloadKey)) {
      sessionStorage.setItem(reloadKey, 'true');
      console.warn('Chunk loading failed, reloading to get fresh assets...');
      window.location.reload();
    }
  }
});

// Also handle unhandled promise rejections (lazy loading uses promises)
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  const message = reason?.message || reason?.toString() || '';
  
  if (
    message.includes('ChunkLoadError') ||
    message.includes('Loading chunk') ||
    reason?.name === 'ChunkLoadError'
  ) {
    const reloadKey = 'chunk_reload_attempted';
    if (!sessionStorage.getItem(reloadKey)) {
      sessionStorage.setItem(reloadKey, 'true');
      console.warn('Chunk loading failed, reloading to get fresh assets...');
      window.location.reload();
    }
  }
});

// Filter out non-critical Supabase lock warnings
const originalError = console.error;
console.error = (...args: any[]) => {
  const message = args[0]?.toString() || '';
  
  // Suppress Supabase Navigator LockManager warnings (non-critical)
  if (
    message.includes('NavigatorLockAcquireTimeoutError') ||
    message.includes('lock:sb-') ||
    message.includes('Acquiring an exclusive Navigator LockManager lock')
  ) {
    return;
  }
  
  // Pass through all other errors
  originalError.apply(console, args);
};

// Display developer credit in console
console.log(`
 ____            _             _       _         
|  _ \\  ___  ___(_) __ _ _ __ | | ___ | |__  ___ 
| | | |/ _ \\/ __| |/ _\` | '_ \\| |/ _ \\| '_ \\/ __|
| |_| |  __/\\__ \\ | (_| | | | | | (_) | |_) \\__ \\
|____/ \\___||___/_|\\__, |_| |_| |\\___/|_.__/|___/
                   |___/                         

Hello!

- Designed & Coded by Carlos Palma
- Portfolio https://www.carlospalma.net
- LinkedIn https://www.linkedin.com/in/cpalma1993/
- Available for freelance projects
`);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
